import Button from 'ext-ui/components/Button/Button'
import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LayoutPage from 'src/component-layout/LayoutPage/LayoutPage'
import CreateExpenseCategoryModal from 'src/component-modal/CreateExpenseCategoryModal/CreateExpenseCategoryModal'
import ExpenseCategoriesList from 'src/components/ExpenseCategoriesList/ExpenseCategoriesList'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import NotFoundBackgroundPage from 'src/components/NotFoundBackgroundPage/NotFoundBackgroundPage'
import { useQueryParamArrayHandler } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import { useQueryUserFeatures } from 'src/queries/auth.queries'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectActiveOrgIntegration } from 'src/redux/selectors/data/orgIntegrations.selectors'
import { selectLoadedFromRemoteConfigState } from 'src/redux/selectors/data/remoteConfig.selectors'
import { selectQueryParams } from 'src/redux/selectors/router.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const ExpenseCategories: React.FC = () => {
  const queryParams = useSelector(selectQueryParams)
  const appName = useSelector(selectAppName)

  const translate = useTranslate()
  const loadedRemoteConfig = useSelector(selectLoadedFromRemoteConfigState)
  const currentUser = useSelector(selectUserListModelFromState)

  const activeIntegration = useSelector(selectActiveOrgIntegration)
  const { EDIT_EXPENSE_CATEGORIES: hasEditExpCatPermissions } =
    useQueryUserFeatures([UserFeature.EDIT_EXPENSE_CATEGORIES]).data || {}

  const [isCreateExpCatModalOpen, setIsCreateExpCatModalOpen] = useState(false)

  if (!loadedRemoteConfig) {
    return <LoadingBackgroundPage />
  }

  if (!currentUser?.hasOrgBookkeeperPermissions) {
    return <NotFoundBackgroundPage />
  }

  return (
    <>
      <Helmet>
        <title>{`Expense Categories | ${appName}`}</title>
        <meta
          name="description"
          content={`Expense Categories page of ${appName}`}
        />
      </Helmet>
      <LayoutPage
        title={<span>{translate('Expense Categories')}</span>}
        actions={
          <>
            {activeIntegration === undefined && hasEditExpCatPermissions && (
              <Button
                data-testid="new-category-btn"
                variant={'primary'}
                dropShadow={false}
                onClick={() => setIsCreateExpCatModalOpen(true)}
              >
                {translate('New Category +')}
              </Button>
            )}
          </>
        }
      >
        <ExpenseCategoriesList
          initialFilterValues={{
            search: (
              useQueryParamArrayHandler(queryParams.search) as string[]
            )?.[0],
            status: useQueryParamArrayHandler(queryParams.status) as string[],
            requiredForVirtualCards: useQueryParamArrayHandler(
              queryParams.requiredForVirtualCards,
            ) as string[],
            requiredForTransactions: useQueryParamArrayHandler(
              queryParams.requiredForTransactions,
            ) as string[],
          }}
        />
        <CreateExpenseCategoryModal
          isOpen={isCreateExpCatModalOpen}
          onClose={() => setIsCreateExpCatModalOpen(false)}
        />
      </LayoutPage>
    </>
  )
}

export default ExpenseCategories
